import { BrowserStorageType, Helper } from "../app/core/util/helper.js";
import { DrawerDirection, DrawerStyle, Drawer } from "./drawer.js";
import { SideTabs } from "./sideTabs.js";
import { SheetManager } from "./sheetManager.js";
import { Config } from "../app/core/config/config.js";
import { StateManger } from "./historyStateManager.js";
import { initGlobalHandler } from "../app/core/util/pageUnloadHandler.js";
import { createHtppServiceInstance, JsonResultClass } from "../app/core/util/httpManager.js";
import { initEdit, Operation } from "../app/remindersEdit/edit.js";
import { AppLauncher } from "./appLauncher.js";
import { Manager, EventType } from "./eventManager.js";
import { DefaultProfilePictureGenerator } from "../app/core/util/defaultProfilePictureGenerator.js";
import { ApplicationRestartHelper } from "../app/applicationRestart/applicationRestart.js";
import { InnosoftMobileApp, startListenToNotificationsFromMobileApp } from "../app/core/util/innosoftMobileApp.js";

export const General = {
    Id: "",
    Elements: {
        SheetContainer: null as JQuery,
        HiddenSheetsContainer: null as JQuery,
        HiddenDrawerContentContainer: null as JQuery,
        NavigationContainer: null as JQuery,
        SideTabsContainer: null as JQuery
    },
    Init: async () => {
        const run = async () => {
            if (Config.settings.isMobileApp && !(window as any).InnosoftMobile && (window as any).onInnosoftMobileIsReady === undefined) {
                await new Promise(resolve => {
                    (window as any).onInnosoftMobileIsReady = resolve;
                });
            }

            General.Id = sessionStorage.TABID &&
                sessionStorage.CLOSEDLASTTAB !== '2' ?
                sessionStorage.TABID :
                sessionStorage.TABID = kendo.guid() + '_' + Date.now();
            sessionStorage.CLOSEDLASTTAB = '2';
            $(window).on('unload beforeunload', function () {
                sessionStorage.CLOSEDLASTTAB = '1';
            });

            //get element references
            General.Elements.SheetContainer = $("#container");
            General.Elements.HiddenSheetsContainer = $("#hidden-sheet-wrappers");
            General.Elements.HiddenDrawerContentContainer = $("#hidden-drawer-content-items");
            General.Elements.NavigationContainer = $("#navigation");
            General.Elements.SideTabsContainer = $("#side-tabs");

            //init navigation
            General.Navigation.Init();

            //set noNorth & noWest
            const queryParameters = Helper.getQueryStringParameters();
            Object.getOwnPropertyNames(queryParameters)
                .map(x => { return { original: x, lower: x.toLowerCase() } })
                .filter(x => x.lower === "nonorth" || x.lower === "nowest" || x.lower === "noeast" || x.lower === "kioskmode")
                .forEach(p => {
                    if (queryParameters[p.original] === "true" || queryParameters[p.original] === "1") {
                        if (p.lower === "nonorth") {
                            $("body").addClass("no-north");
                        } else if (p.lower === "nowest") {
                            $("body").addClass("no-west");
                        } else if (p.lower === "noeast") {
                            $("body").addClass("no-east");
                        } else if (p.lower === "kioskmode") {
                            $("body").addClass("kiosk-mode");
                        }
                    }
                });

            if (Helper.useMobileGui()) {
                document.body.classList.add("mobile");
                InnosoftMobileApp.isMobileDevice().then(isMobileDevice => {
                    if (isMobileDevice)
                        document.body.classList.add("smallscreen");
                })
            }
            if (Config.settings.isMobileApp) {
                document.body.classList.add("no-north", "no-east", "no-west", "mobileapp");
                startListenToNotificationsFromMobileApp();

                let dateTimeFormat = Config.settings.mobileAppCulture.dateTimeFormat;
                let numberFormat = Config.settings.mobileAppCulture.numberFormat;
                kendo.culture().calendar.patterns.d = dateTimeFormat.shortDatePattern;
                kendo.culture().calendar.patterns.T = dateTimeFormat.longTimePattern;
                kendo.culture().calendar.patterns.t = dateTimeFormat.shortTimePattern;
                kendo.culture().calendar.patterns.g = `${dateTimeFormat.shortDatePattern}${dateTimeFormat.dateTimeSeparator}${dateTimeFormat.shortTimePattern}`;
                kendo.culture().calendar.patterns.G = `${dateTimeFormat.shortDatePattern}${dateTimeFormat.dateTimeSeparator}${dateTimeFormat.longTimePattern}`;
                kendo.culture().numberFormat[","] = numberFormat.numberGroupSeparator;
                kendo.culture().numberFormat["."] = numberFormat.numberDecimalSeparator;
                kendo.culture().numberFormat.currency[","] = numberFormat.numberGroupSeparator;
                kendo.culture().numberFormat.currency["."] = numberFormat.numberDecimalSeparator;
            }

            let ctrl = false;
            let shift = false;
            let alt = false;
            //use "ESC" key to close the current sheet (but not the first one...)
            $(document).keyup((e) => {
                if (Config.settings.smartSearchActive) {
                    navigationShortCuts["g"]["s"] = "Smartsearch/init";
                }

                let $focused = $(':focus').not("a")[0];
                //if (e.keyCode === 27) {
                if (e.keyCode === 27) {
                    // :]
                    if (Helper.hasValue($focused)) {
                        $focused.blur();
                    } else if (document.querySelectorAll('div.k-overlay ~ div[role="dialog"]').length == 0) {
                        const topSheet = General.Sheet.Manager.getTopMostVisibleSheet();
                        if (!topSheet.isHiding() && !topSheet.isRemoving() && !topSheet.isShowing() && General.Sheet.Manager.getVisibleSheetsCount() > 1 && topSheet !== General.Sheet.Manager.getSheetByIndex(0)) {
                            const kendoWindow = topSheet.elements.getElement().data("kendoWindow");
                            if (kendoWindow) {
                                kendoWindow.close();
                            } else {
                                topSheet.hide();
                            }
                        }
                    }
                }
                ctrl = false;
                shift = false;
                alt = false;
            });


            let lastKey: string = "";

            $(document).keydown((e) => {
                let contentActive: boolean = Helper.getValueOrDefault((e.target as any).getAttribute("contenteditable"), false);
                let $focused = $(':focus').not("a")[0];
                if (e.ctrlKey) {
                    ctrl = true;
                }
                if (e.altKey) {
                    alt = true;
                }
                if (e.shiftKey) {
                    shift = true;
                }

                if ((["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12"].indexOf(e.key) === -1) && (Object.keys(navigationShortCuts).indexOf(lastKey) == -1)) {
                    let key = e.key;
                    if (!Helper.isNullOrEmpty(key)) {
                        key = key.toLocaleLowerCase();
                    }
                    let shortcut: KeyboardShortcut = {
                        key: key,
                        alt: alt,
                        ctrl: ctrl,
                        shift: shift
                    };

                    let lst = sheetHandlingShortCuts.filter(f => f.key === shortcut.key && f.ctrl === shortcut.ctrl && f.alt === shortcut.alt && f.shift === shortcut.shift)
                    if (lst.length === 1) {
                        e.preventDefault();
                        General.Events.trigger(EventType.ShortCut, shortcut);
                    }


                    //if (!Helper.hasValue($focused) && (!ctrl && !alt && !shift)) {
                    //    General.Events.trigger(EventType.ShortCut, shortcut);
                    //} else if (ctrl && !alt && !shift && e.key.toLowerCase() === "s") {
                    //    debugger;
                    //    e.preventDefault();
                    //    General.Events.trigger(EventType.ShortCut, shortcut);
                    //}
                }

                //Navigation
                if (Object.keys(navigationShortCuts).indexOf(lastKey) > -1 && !Helper.hasValue($focused) && !contentActive && !shift && !ctrl && !alt) {
                    let urls = navigationShortCuts[lastKey];
                    let url = urls[e.key];
                    if (Helper.hasValue(url)) {
                        let openHotKeyInNewTab: boolean = Helper.getValueOrDefault(Config.user.openHotKeyInNewTab, false)
                        lastKey = "";
                        if (openHotKeyInNewTab) {
                            Helper.openInNewBrowserTab(Config.baseUrl + url);
                        } else {
                            window.location.href = Config.baseUrl + url;
                        }
                    }
                }

                //reset after 3 seconds
                if (!Helper.hasValue($focused)) {
                    lastKey = e.key;
                    if (!Helper.isNullOrEmpty(lastKey)) {
                        setTimeout(_ => {
                            lastKey = "";
                        }, 3000);
                    }
                }
            });

            //init drawers
            General.Drawer.Left = new Drawer($("#left-drawer"), DrawerDirection.FromLeft, General.Elements.HiddenDrawerContentContainer, DrawerStyle.SlideContent, true, true);
            //General.Drawer.Right = new Drawer($("#right-drawer"), Objects.DrawerDirection.FromRight, Objects.DrawerStyle.SlideContent, false);

            ///////////////////////////////////////////////////////////////////////
            //General.Drawer.Right.disable();
            //if (Helper.hasValue(General.Elements.SideTabsContainer) && General.Elements.SideTabsContainer.length === 1) {
            General.Drawer.SideTabs = new SideTabs(General.Elements.SideTabsContainer);
            //}

            //const e1 = General.Drawer.SideTabs
            //    .addTab({ name: "x1", iconName: "eye", type: Objects.SideTabType.Global, onSelect: () => { } })
            //    .html("<div style='background-color: greenyellow;height: 100%;'><b>X1 CONTENT</b></div>");
            //const e2 = General.Drawer.SideTabs
            //    .addTab({ name: "x2", iconName: "map-marker-alt", type: Objects.SideTabType.Global, onSelect: () => { } })
            //    .html("<div style='background-color: orange;height: 100%;'><b>X2 CONTENT</b></div>");


            ///////////////////////////////////////////////////////////////////////


            //init the sheet manager
            General.Sheet.Manager = new SheetManager({
                sheetContainer: General.Elements.SheetContainer,
                hiddenContainer: General.Elements.HiddenSheetsContainer,
                leftDrawer: General.Drawer.Left,
                //rightDrawer: General.Drawer.Right
            });

            //init responsive listener (just one brakpoint for now...)
            const mediaQueries = [750];
            const mediaQuery = "(max-width:" + mediaQueries[0] + "px)";
            const mediaQueryChanged = (value, isOn) => {
                //console.log("media query for " + value + " has been " + (isOn ? "activated" : "deactivated"));
                if (General.Drawer.SideTabs != null) {
                    if (isOn) {
                        General.Drawer.SideTabs.close();
                        General.Drawer.SideTabs.hide();
                        General.Drawer.Left.close();
                    } else {
                        General.Drawer.SideTabs.show();
                    }
                }
            }
            const mql = window.matchMedia(mediaQuery);
            mql.addListener(function () {
                mediaQueryChanged(mediaQueries[0], mql.matches);
            });
            //trigger to check after loading
            mediaQueryChanged(mediaQueries[0], mql.matches);

            initGlobalHandler();

            General.Functions.HistoryState.init();
            const heartbeat = async () => {
                const res = await createHtppServiceInstance().noBusyIndicator().post("Heartbeat.ashx");
                //update reminder
                if (res && Helper.hasValue(res.ReminderTotal) && Helper.hasValue(res.ReminderUnseen)) {
                    const el = $("#logout-form__menu__reminders");
                    if (el.length == 1)
                        el.text(res.ReminderUnseen + "/" + res.ReminderTotal);
                }
                //update reset 
                if (res && Helper.hasValue(res.RestartUtc))
                    ApplicationRestartHelper.processHeartbeat(res.RestartUtc);
            }

            if (Config.user.userName && Config.user.userName.trim() !== "") {
                await heartbeat();
                setInterval(async () => {
                    await heartbeat();
                }, 30000);
            }

            Innosoft.layoutInitialized = true;

            General.Events.trigger(EventType.SystemInitialized);
        }

        if (document.readyState !== 'loading') {
            run()
        } else {
            document.addEventListener('DOMContentLoaded', run);
        }
    },
    Navigation: {
        Init: () => {
            General.Elements.NavigationContainer.on("click", ".navigation-content__module", (ev) => {
                const target = $(ev.currentTarget);
                const dataModuleId: number = target[0].getAttribute("data-module-id")
                Helper.saveDataToStorage("innosoft_menu_last_clicked", dataModuleId, false, BrowserStorageType.Session);
                if (!target.hasClass("active")) {
                    const idx = $(".navigation-content__module", General.Elements.NavigationContainer).index(target);
                    $(".navigation-content__module.active", General.Elements.NavigationContainer).removeClass("active");
                    $(".navigation-content__site.active.active", General.Elements.NavigationContainer).removeClass("active");

                    $(target).addClass("active");
                    $(".navigation-content__site", General.Elements.NavigationContainer).eq(idx).addClass("active");
                }
            });
        },
        SetBreadcrumbs: (parts: Array<string>) => {
            const breadcrumbs = $("#breadcrumbs");
            breadcrumbs.empty();
            if (Array.isArray(parts)) {
                for (let i = 0; i < parts.length - 1; i++) {
                    const span = $("<span>").text(parts[i]);
                    const icon = $("<i>").addClass("fal fa-chevron-right fa-fw").attr("aria-hidden", "true");
                    breadcrumbs.append(span);
                    breadcrumbs.append(icon);
                }
                const span = $("<span>").text(parts[parts.length - 1]);
                breadcrumbs.append(span);
            }
        },
        AddEntry: (entry: NavigationModule | Array<NavigationModule>) => {
            const hv = Helper.hasValue;
            let source: Array<NavigationModule> = [];
            if (Array.isArray(entry)) {
                source = entry;
            } else {
                if (hv(entry)) {
                    source.push(entry);
                }
            }

            if (source.length > 0) {
                const existing: Array<NavigationModule> = [];
                const groupContainers = $(".navigation-content__site", General.Elements.NavigationContainer);

                $(".navigation-content__module", General.Elements.NavigationContainer).each((mi, me) => {
                    const module: NavigationModule = {
                        id: parseInt($(me).attr("data-module-id"), 10),
                        text: $(">span", me).text(),
                        groups: []
                    };

                    const gc = groupContainers.filter(`[data-module-id=${module.id}]`)[0];
                    if (hv(gc)) {
                        $("> li", gc).each((gi, ge) => {
                            const group: NavigationGroup = {
                                id: parseInt($(ge).attr("data-group-id"), 10),
                                text: $(">label>span", ge).text(),
                                items: []
                            };

                            $(">ul>li", ge).each((ii, ie) => {
                                const item: NavigationItem = {
                                    id: parseInt($(ie).attr("data-site-id"), 10),
                                    text: $(">a", ie).text()
                                };

                                group.items.push(item);
                            });

                            module.groups.push(group);
                        });
                    }

                    existing.push(module);
                });

                source.forEach(m => {
                    const modules = existing.filter(x => x.id === m.id);

                    if (modules.length === 0) {
                        General.Navigation.Tools.AddModule(m);
                    } else {
                        const targetModule = modules[0];

                        m.groups.forEach(g => {
                            const groups = targetModule.groups.filter(x => x.id === g.id);

                            if (groups.length === 0) {
                                General.Navigation.Tools.AddGroup(targetModule.id, g);
                            } else {
                                const targetGroup = groups[0];

                                g.items.forEach(i => {
                                    General.Navigation.Tools.AddItem(targetModule.id, targetGroup.id, i);
                                })
                            }
                        });
                    }
                });
            }
        },
        Tools: {
            AddItemToGroup: (group: JQuery, item: NavigationItem) => {
                const newItem = $("<li>");
                newItem.attr({ "data-site-id": item.id, title: item.text });
                const icon = $("<i>").addClass("fal fa-fw fa-" + (item.icon || ""));
                icon.attr("aria-hidden", "true");
                newItem.append(icon);
                const link = $("<a>").text(item.text).addClass("k-link");
                link.attr("href", item.url);
                newItem.append(link);

                $(">ul", group).append(newItem);
            },
            AddItem: (moduleId: number, groupId: number, item: NavigationItem) => {
                const module = $(`.navigation-content__site[data-module-id=${moduleId}]`, General.Elements.NavigationContainer);
                const group = $(`>li[data-group-id=${groupId}]`, module);
                General.Navigation.Tools.AddItemToGroup(group, item);
            },
            AddGroupToModule: (module: JQuery, group: NavigationGroup) => {
                const newGroup = $("<li>")
                newGroup.attr("data-group-id", group.id);
                const lbl = $("<label>");
                lbl.attr("title", group.text);
                const icon = $("<i>").addClass("fal fa-fw fa-" + (group.icon || ""));
                icon.attr("aria-hidden", "true");
                lbl.append(icon);
                const span = $("<span>").addClass("truncate");
                span.text(group.text);
                lbl.append(span);
                newGroup.append(lbl);
                const items = $("<ul>");
                newGroup.append(items);
                group.items.forEach(i => General.Navigation.Tools.AddItemToGroup(newGroup, i));
                module.append(newGroup);
            },
            AddGroup: (moduleId: number, group: NavigationGroup) => {
                const module = $(`.navigation-content__site[data-module-id=${moduleId}]`, General.Elements.NavigationContainer);
                General.Navigation.Tools.AddGroupToModule(module, group);
            },
            AddModule: (module: NavigationModule) => {
                const moduleBox = $("<div>").addClass("navigation-content__module");
                moduleBox.attr({ title: module.text, "data-module-id": module.id });
                const moduleSpan = $("<span>").text(module.text);
                moduleBox.append(moduleSpan);
                const icon = $("<i>").addClass("fal fa-fw fa-5x fa-" + (module.icon || ""));
                icon.attr("aria-hidden", "true");
                moduleBox.append(icon);

                const moduleGroups = $("<ul>").addClass("navigation-content__site");
                moduleGroups.attr("data-module-id", module.id);
                module.groups.forEach(g => General.Navigation.Tools.AddGroupToModule(moduleGroups, g));

                $("#navigation-content__modules", General.Elements.NavigationContainer).append(moduleBox);
                $("#navigation-content__sites", General.Elements.NavigationContainer).append(moduleGroups);
            }
        }
    },
    Sheet: {
        Manager: null as SheetManager,
        GetTopMostWrapper: (): JQuery => {
            return $(".sheet-wrapper", General.Elements.SheetContainer).last();
        },
    },
    Content: {
        AppendHiddenContent: (content: JQuery | string): JQuery => {
            const wrapper = $("<div>").addClass("hidden-content").hide().appendTo($("body"));
            if (typeof content === "string") {
                wrapper.html(content);
            } else {
                wrapper.append(content);
            }
            return wrapper;
        },
        MountComponent: (component, props) => {
            let sheet = General.Sheet.Manager.getTopMostSheet();

            if (sheet && sheet.awaitsComponentInitialization()) {
                sheet.mountContent(component, props);
            } else {
                sheet = General.Sheet.Manager.createSheet();
                sheet.mountContent(component, props);
                if (Helper.hasValue(props) && Helper.hasValue(props.isWindow) && props.isWindow === false) {
                    const host = window.location.host + Config.baseUrl;
                    const startIdx = window.location.href.indexOf(host) + host.length;
                    sheet.setSourceUrl(window.location.href.substr(startIdx));
                }
            }
        },
    },
    Drawer: {
        Left: null as Drawer,
        //Right: null as Objects.Drawer,
        SideTabs: null as SideTabs
    },
    Functions: {
        HistoryState: StateManger,
        Reminders: {
            QuickAdd: () => {
                const sheet = General.Sheet.Manager.createSheet();
                sheet.show(() => {
                    initEdit({ sheet: sheet, operation: Operation.Add, targetUrl: window.location.href });
                });
            },
            ShowAll: () => {
                const sheet = General.Sheet.Manager.createSheet(null, true);
                sheet.awaitsComponentInitialization(true);
                sheet.show(() => {
                    AppLauncher({
                        "controller": "Tasks",
                        "action": "Index",
                        "targetApp": null,
                        "title": Config.translations.reminders.reminders,
                        "isWindow": true,
                        "keyName": null,
                        "keyValue": null,
                        "secondKeyName": null,
                        "secondKeyValue": null
                    }, { "url": null });
                });
            },
            Init: (onUpdateCallback: (total: number, unseen: number) => void) => {
                const call = () => {
                    createHtppServiceInstance().noBusyIndicator().get<JsonResultClass<{ total: number; unseen: number; }>>("Tasks/GetTasksCount")
                        .then(result => {
                            if (result.Data && Helper.hasValue(result.Data.total) && Helper.hasValue(result.Data.unseen))
                                onUpdateCallback(result.Data.total, result.Data.unseen);
                            else
                                onUpdateCallback(0, 0);
                        });
                };

                //disable hier => now works over Heartbeat.ashx 
                // setInterval(call, 60000);
                // call();

                $(window).on("refreshReminders", call);
            }
        }
    },
    Events: Manager,
    AddShortcut: (first: string, second: string, path: string) => {
        if (Helper.isNullOrEmpty(first) || first.length != 1 || Helper.isNullOrEmpty(second) || second.length != 1 || Helper.isNullOrEmpty(path))
            return;
        const inner = {};
        inner[second] = path;
        const outer = {}
        outer[first] = inner;
        Object.assign(navigationShortCuts, outer)
    },
    ProfilePicture: {
        GenerateDefault: (size: number) => {
            const name = Config.user.fullName;
            if (Helper.isNullOrEmpty(name))
                return null;
            return DefaultProfilePictureGenerator.generateNode(name, size)
        }
    }

}

const navigationShortCuts = {
    "g": {
        "p": "ResourcePlanningScheduler",
        "h": "",
        "g": "GeneralSettings/Edit",
        "u": "UserSettings/Edit",
        "t": "Tasks",
        "b": "Bookmark?nowest=true&noeast=true"
    },
    "l": {
        "m": "DynamicSearch/Machine",
        "d": "DynamicSearch/Address",
        "o": "DynamicSearch/Contact",
        "e": "DynamicSearch/Resource",
        "s": "DynamicSearch/Parts",
        "p": "DynamicSearch/Project",
        "a": "DynamicSearch/Assignment",
        "r": "DynamicSearch/Servicereport",
        "w": "DynamicSearch/WeeklyReport",
        "t": "DynamicSearch/Procedure",
        "l": "DynamicSearch/SlaAgreement",
        "c": "DynamicSearch/crReport",
        "v": "DynamicSearch/travelReport"
    }
}

const sheetHandlingShortCuts: KeyboardShortcut[] = [
    {
        key: "s",
        alt: false,
        shift: false,
        ctrl: true
    },
    {
        key: "d",
        alt: true,
        shift: false,
        ctrl: true
    },
    {
        key: "i",
        alt: false,
        shift: false,
        ctrl: true
    },
    {
        key: "g",
        alt: true,
        shift: false,
        ctrl: true
    },
    {
        key: "n",
        alt: true,
        shift: false,
        ctrl: true
    },
    {
        key: "m",
        alt: false,
        shift: false,
        ctrl: true
    },
    {
        key: "f",
        alt: true,
        shift: false,
        ctrl: true
    },
    {
        key: "p",
        alt: false,
        shift: false,
        ctrl: true
    }

]

interface NavigationModule {
    text: string;
    icon?: string;
    id?: number;
    groups: Array<NavigationGroup>;
}

interface NavigationGroup {
    text: string;
    icon?: string;
    id?: number;
    items?: Array<NavigationItem>;
}

interface NavigationItem {
    text: string;
    icon?: string;
    id?: number;
    url?: string;
}

export interface KeyboardShortcut {
    ctrl: boolean;
    shift: boolean;
    alt: boolean;
    key: string;
}